"use client";

import type { ConditionalFieldRules } from "@huub-web/ui/types/ConditionalFieldRules";

import { useTemplates } from "./useTemplates";
import { isConditionalIf } from "../utils";

/**
 * Hook for checking if an input field is disabled based on the provided rules.
 * @param rules - The rules to check the disabled state against.
 * @returns An object containing the disabled state of the input field.
 */
export const useDisabledIf = (rules?: ConditionalFieldRules) => {
  const { dataFieldValues } = useTemplates();

  if (!rules || rules.length === 0) {
    return { isDisabled: false };
  }

  const isDisabled = isConditionalIf(rules, dataFieldValues);

  return { isDisabled };
};
